
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goroskop/[zodiac]",
      function () {
        return require("private-next-pages/goroskop/[zodiac].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goroskop/[zodiac]"])
      });
    }
  